import { Group, Text } from "@mantine/core";
import type { ReactNode } from "react";

interface OverviewStatProps {
	value: number;
	label: string;
	color?: string;
	icon?: ReactNode;
	// The same count under the page's current filters; omitted when unfiltered
	filteredValue?: number | null;
}

function OverviewStat({ value, label, color, icon, filteredValue }: OverviewStatProps) {
	return (
		<div>
			<Group
				gap="xs"
				align="center">
				<Text
					size="xl"
					fw={700}
					c={color}>
					{value}
				</Text>
				{icon}
			</Group>
			{filteredValue != null && (
				<Text
					size="sm"
					fw={600}
					c="blue">
					{filteredValue} filtered
				</Text>
			)}
			<Text
				size="sm"
				c="dimmed">
				{label}
			</Text>
		</div>
	);
}

export default OverviewStat;
